"use client";

import { cn } from "@/utils/classnames";

type Props = {
  backgroundUrl: string;
  applyTheme?: boolean | null;
};

export const NavigationBackgroundImage = ({
  backgroundUrl,
  applyTheme = false,
}: Props) => {
  return (
    <>
      <div
        className="mx-auto h-full w-full max-w-300 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${backgroundUrl})` }}
        data-testid="navigation-background-image"
        aria-hidden="true"
      />

      <div
        className={cn(
          "absolute top-0 left-1/2 h-full w-full max-w-300 -translate-x-1/2 opacity-25",
          {
            "bg-(--theme-color-background-body)": !applyTheme,
            "bg-(--theme-color-background-brand)": applyTheme,
          }
        )}
        aria-hidden="true"
      />

      <div
        className={cn(
          "absolute top-0 left-1/2 h-full w-full max-w-300 -translate-x-1/2",
          {
            "bg-linear-to-b from-(--theme-color-background-body)/10 to-(--theme-color-background-body)/15":
              !applyTheme,
            "bg-linear-to-b from-(--theme-color-background-brand)/10 to-(--theme-color-background-brand)/15":
              applyTheme,
          }
        )}
        aria-hidden="true"
      />

      <div
        className={cn(
          "absolute top-0 left-1/2 hidden h-full w-full max-w-300 -translate-x-1/2 bg-radial-[circle] md:block",
          {
            "from-[rgba(255,255,255,0)] from-40% to-(--theme-color-background-body)":
              !applyTheme,
            "from-[rgba(255,255,255,0)] from-40% to-(--theme-color-background-brand)":
              applyTheme,
          }
        )}
        aria-hidden="true"
      />
    </>
  );
};
